import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

import { BundleSearchInput } from './BundleSearchInput';
import { BundleProductFilter } from './BundleProductFilter';
import { BundleDateFilter } from './BundleDateFilter';
import { BundleApplyButton } from './BundleApplyButton';
import { BundleResetButton } from './BundleResetButton';

const filterContainerStyles = xcss({
  display: 'flex',
  gap: 'space.100',
  flexWrap: 'wrap',
  alignItems: 'center',
});

const filterActionsStyles = xcss({
  display: 'flex',
  gap: 'space.100',
  alignItems: 'center',
  flexShrink: 0,
});

export const BundledChangesFilters: React.FC = () => {
  return (
    <Box
      xcss={filterContainerStyles}
      testId="app-updates-bundle-filters-testid"
    >
      <BundleSearchInput />
      <BundleProductFilter />
      <BundleDateFilter />
      <Box xcss={filterActionsStyles}>
        <BundleApplyButton />
        <BundleResetButton />
      </Box>
    </Box>
  );
};
